import React, { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import Modal from '../base/modal';
import Timeout from '../../assets/svgs/network-timeout.png';
import AppButton from './button';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store';

const IDLE_TIMEOUT = 2 * 60 * 1000; // 2 minutes
const COUNTDOWN_START = 60; // 60 seconds

const IdleScreen: React.FC = () => {
  const navigate = useNavigate();
  const { removeAuthStateFromStorage, isAuthenticated } = useAuthStore();
  const authState: any = useAuthStore().loadAuthStateFromStorage();
  const isUserAuthenticated = isAuthenticated() && authState;

  const [isIdle, setIsIdle] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN_START);

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: () => setIsIdle(true),
    debounce: 500, // Avoid false triggers
  });

  useEffect(() => {
    if (!isIdle) return;

    const endTime = Date.now() + COUNTDOWN_START * 1000;

    const countdownInterval = setInterval(() => {
      const remaining = Math.max(Math.round((endTime - Date.now()) / 1000), 0);
      setCountdown(remaining);

      if (remaining <= 0) {
        clearInterval(countdownInterval);
        handleLogout();
      }
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [isIdle]);

  const handleContinueSession = () => {
    setIsIdle(false);
    setCountdown(COUNTDOWN_START);
  };

  const handleLogout = () => {
    setIsIdle(false);
    removeAuthStateFromStorage();
    navigate('/login');
  };

  if (!isUserAuthenticated) return null;

  return (
    <Modal isOpen={isIdle} showCloseButton={false} width="w-[700px] h-fit">
      <div className="p-6 text-center flex flex-col gap-4 w-[500px] mx-auto">
        <div className="flex justify-center items-center">
          <img src={Timeout} alt="Session Timeout Warning" />
        </div>
        <p className="text-xl font-bold">Session Timeout Warning</p>
        <p className="text-gray-600 mb-6 mx-auto">
          Your session will expire in{' '}
          <span className="font-semibold text-black">{countdown}</span> seconds
          due to inactivity. Would you like to continue your session?
        </p>
        <div className="flex gap-4">
          <AppButton label="Logout" type="error" clicked={handleLogout} />
          <AppButton label="Continue Session" clicked={handleContinueSession} />
        </div>
      </div>
    </Modal>
  );
};

export default IdleScreen;
